import { render, staticRenderFns } from "./send-collect-customer.vue?vue&type=template&id=ce8ee07e&scoped=true"
import script from "./send-collect-customer.vue?vue&type=script&lang=ts"
export * from "./send-collect-customer.vue?vue&type=script&lang=ts"
import style0 from "./send-collect-customer.vue?vue&type=style&index=0&id=ce8ee07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8ee07e",
  null
  
)

export default component.exports